import Button from "@shared/components/button/Button";
import { BUTTON_SIZE } from "@shared/components/button/types";
import IconRingtoneCheck from "@svg/new-design/ringtone-check";
import IconRinging from "@svg/product/Ringing";
interface Props {
  notified: boolean;
  loading: boolean;
  onPreRegister: () => void;
}

const NotPublishedSidebarAction: React.FC<Props> = ({
  loading,
  notified,
  onPreRegister,
}) => {
  return (
    <Button
      startIcon={
        notified ? (
          <IconRingtoneCheck className="w-6  h-6  text-fds-icon-secondary" />
        ) : (
          <IconRinging className="w-6  h-6" />
        )
      }
      size={BUTTON_SIZE.XLARGE}
      onClick={onPreRegister}
      className="grow"
      disabled={loading || notified}
    >
      {notified ? " پیش ثبت‌نام شده " : " منتشر شد خبرم کن! "}
    </Button>
  );
};

export default NotPublishedSidebarAction;
